module.exports = __webpack_public_path__ + "img/Restaurant location pin Icon - charcoal.fd5bc3c5.svg";